/**
 * Convert a File or Blob to a raw base64 string (no data-URL prefix).
 *
 * This is the imperative/Promise-based counterpart of the `useFileToBase64`
 * hook - use it in event handlers and other non-reactive contexts.
 *
 * @example
 * ```ts
 * const base64 = await fileToBase64(file);
 * ```
 */
export function fileToBase64(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        // Strip "data:<mime>;base64," prefix - backends expect only the payload
        const commaIndex = reader.result.indexOf(',');
        const raw = commaIndex !== -1 ? reader.result.slice(commaIndex + 1) : reader.result;
        resolve(raw);
      } else {
        reject(new Error('Failed to read file'));
      }
    };
    reader.onerror = () => reject(reader.error);
  });
}
